import React from 'react';
import { Cushion, Grid, Select, Typography } from '@pitchero/react-ui';
import { find, identity, isEmpty, map, pickBy } from 'lodash';
import PropTypes from 'prop-types';
import { Trans } from '../../lib/i18n';

const AddressSelector = ({ locations, setSelectedLocation, selectedLocation }) => {
  const onLocationChange = (event) => {
    const locationId = parseInt(event.target.value, 10);
    const newSelectedLocation = find(locations, (location) => location.id === locationId);
    setSelectedLocation(newSelectedLocation);
  };

  const printableAddress = (location) => {
    const { address1, address2, address3, address4, postcode, telephone } = location;

    return pickBy(
      {
        address1,
        address2,
        address3,
        address4,
        postcode,
        telephone,
      },
      identity,
    );
  };

  const selectOptions = () =>
    locations.map((location) => ({
      value: `${location.id}`,
      name: location.name,
    }));

  return (
    <Grid columns="auto" style={{ height: '100%', boxSizing: 'border-box' }}>
      <Cushion horizontal="xlarge" top="xlarge" bottom="medium">
        {!isEmpty(locations) && locations.length > 1 && (
          <Cushion bottom="medium" component="div" style={{ maxWidth: '100%' }}>
            <Select
              options={selectOptions()}
              onChange={onLocationChange}
              style={{
                borderRadius: '24px',
                backgroundColor: '#e7e7e7',
                color: 'black',
                border: 'none',
                boxShadow: 'none',
                fontFamily: 'montserrat',
                fontWeight: 600,
                size: 16,
                lineHeight: '18px',
              }}
            />
          </Cushion>
        )}

        {selectedLocation && locations.length === 1 && (
          <Cushion bottom="medium">
            <Typography preset="subtitle--large" component="div" color="black">
              {selectedLocation.name}
            </Typography>
          </Cushion>
        )}

        {selectedLocation &&
          map(printableAddress(selectedLocation), (field) => (
            <Typography preset="body--small" component="div" key={field} color="black">
              {field}
            </Typography>
          ))}
      </Cushion>

      {selectedLocation && selectedLocation.lat !== 0 && selectedLocation.lng !== 0 && (
        <Cushion bottom="xlarge" horizontal="xlarge">
          <Typography
            transform="uppercase"
            preset="subtitle--small"
            color="primary"
            component="a"
            href={`https://maps.google.com/maps?z=12&t=m&q=${selectedLocation.lat},${selectedLocation.lng}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Trans i18nKey="common:view_on_google_maps">View on google maps</Trans>
          </Typography>
        </Cushion>
      )}
    </Grid>
  );
};

AddressSelector.defaultProps = {
  selectedLocation: {
    lng: null,
    lat: null,
  },
};

AddressSelector.propTypes = {
  locations: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  setSelectedLocation: PropTypes.func.isRequired,
  selectedLocation: PropTypes.shape(),
};

export default AddressSelector;
